import { Box } from '@rbilabs/universal-components';

export const LogoContainer = Box.withConfig({
  alignSelf: 'center',
  width: '$32',
  marginTop: {
    base: '$4',
  },
});

export const QRContainer = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '2em',
  marginBottom: '1em',
});

export const QRWrapper = Box.withConfig({
  padding: '0.75em',
  backgroundColor: 'white',
});

export const PickupPin = Box.withConfig({
  padding: '$2',

  _text: {
    textAlign: 'center',
    fontSize: '3xl',
  },
});
